import Cookie from "./cookie";
import { STORAGE } from "../constants";
import { getDomain } from "./domain";

export const isDev = () => {
  return (
    location.hostname.includes("account-pre") ||
    location.hostname.includes("task-pre") ||
    location.hostname.includes("share-pre") ||
    isLocalhost()
  );
};

export const isPictureClientDev = () => {
  return location.hostname.includes("picture-client-pre") || isLocalhost();
};

export const isLocalhost = () => {
  return (
    location.hostname.includes("localhost") ||
    location.hostname.includes("0.0.0.0") ||
    location.hostname.includes("127.0.0.1")
  );
};

export const isTestOrProduct = () => {
  return (
    location.hostname.includes("account-pre.") ||
    location.hostname.includes("account.")
  );
};

export const isRenderClientTestOrProduct = () => {
  return (
    location.hostname.includes("picture-client-pre.") ||
    location.hostname.includes("picture-client.")
  );
};

export const goToMainRoute = (isNeedLocationSearch = true) => {
  const route = process.env.NODE_ENV === "development" ? "start" : "sso";
  let search = "";
  if (isNeedLocationSearch) {
    search = location.search;
    if (location.pathname.length > 1) {
      search = search
        ? `${search}&redirectPath=${location.pathname}`
        : `?redirectPath=${location.pathname}`;
    }
  }

  const blockComeFrom = Cookie.getCookie(STORAGE.BLOCK_COME_FROM);
  if (!blockComeFrom || Date.now() > +blockComeFrom) {
    let referrer = document.referrer || document.URL;
    if (document.referrer && window.location.search.includes("source=")) {
      if (referrer.includes("&")) {
        referrer = `${referrer}&${window.location.search.slice(1)}`;
      } else {
        referrer += window.location.search;
      }
    }
    // 记录24小时内不可覆盖
    Cookie.setCookie(
      STORAGE.BLOCK_COME_FROM,
      new Date().setDate(new Date().getDate() + 1) as unknown as string,
      1
    );
    // 记录保持7天
    Cookie.setCookie(STORAGE.COME_FROM, referrer, 7);
  }
  if (isLocalhost()) {
    location.href = `${location.protocol}//${location.host}/${route}${search}`;
    return;
  }
  location.href = `${host}/${route}${search}`;
};

export const isEn = () => Number(Cookie.getCookie(STORAGE.LANGUAGE_FLAG)) === 1;
export const locale = () => (isEn() ? "en" : "zh");
export const isFox = getDomain() === 1;
export const host = isLocalhost()
  ? ""
  : isDev()
  ? getDomain()
    ? "https://task-pre.foxrenderfarm.com"
    : "https://task-pre.renderbus.com"
  : getDomain()
  ? "https://task.foxrenderfarm.com"
  : "https://task.renderbus.com";

export const userCenterHost = isDev()
  ? getDomain()
    ? "https://account-pre.foxrenderfarm.com/center/user"
    : "https://account-pre.renderbus.com/center/user"
  : getDomain()
  ? "https://account.foxrenderfarm.com/center/user"
  : "https://account.renderbus.com/center/user";
